import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavBar } from '../../components/NavBar';
import { Footer } from '../../components/Footer';
import { Cart } from '../../components/Cart';
import { fetchProductsTypes } from '../../statemanagement/actions/products';
import Modal from 'react-bootstrap/Modal';
import { Col } from 'react-bootstrap';
import "./Menu.css";
import logoPlaceholder from '../../assets/logo.png'; 
import LoadingModal from '../../components/LoadingModal';
// import { domain } from '../../domain';

const Menu = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // Get dynamic types from Redux
    const { productTypes, loadingProductTypes} = useSelector(state => state.ProductsReducer);
    const [showCart, setShowCart] = useState(false);
    // const [featuredProduct, setFeaturedProduct] = useState(null);
    // const [showFeaturedModal, setShowFeaturedModal] = useState(false);
    // Fetch types on mount
    useEffect(() => {
        dispatch(fetchProductsTypes());
    }, [dispatch]);

    // useEffect(() => {
    //     const fetchFeaturedProduct = async () => {
    //         try {
    //             // Adjust this URL to match your actual Django API routing
    //             const response = await fetch(`${domain}/api/product-featured/`); 
    //             if (response.ok) {
    //                 const data = await response.json();
                    
    //                 // Check if the user has already seen this specific product
    //                 const hasSeen = localStorage.getItem(`seenFeatured_${data.id}`);
                    
    //                 if (!hasSeen && data) {
    //                     setFeaturedProduct(data);
    //                     setShowFeaturedModal(true);
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("Error fetching featured product:", error);
    //         }
    //     };

    //     fetchFeaturedProduct();
    // }, []);

    const scrollRef = useRef(null);

    // const handleCloseFeatured = () => {
    //     if (featuredProduct) {
    //         // Save to local storage so it doesn't pop up again for this specific product
    //         localStorage.setItem(`seenFeatured_${featuredProduct.id}`, 'true');
    //     }
    //     setShowFeaturedModal(false);
    // };

    const scroll = (direction) => {
        if (scrollRef.current) {
            const { scrollLeft, clientWidth } = scrollRef.current;
            // Adjust '300' to change how far it scrolls per click
            const scrollTo = direction === 'left' ? -300 : 300;
            scrollRef.current.scrollBy({ left: scrollTo, behavior: 'smooth' });
        }
    };

    const getOptimizedUrl = (url, width = 800) => {
        if (!url || !url.includes('cloudinary.com')) return url;
        if(width === 500) {
            return url.replace('/upload/', `/upload/f_auto,q_60,w_${width}/`);
        }
        return url.replace('/upload/', `/upload/f_auto,q_10,w_${width}/`);
    };



    return(
        !loadingProductTypes && productTypes?.length > 0 ? ( 
        <div>
            <div className='sticky'>
                <NavBar />
                <div className="menu-wrapper">
                    {/* Left Arrow */}
                    <button className="nav-btn left" onClick={() => scroll('left')}>‹</button>

                    <div className="scrollmenu" ref={scrollRef}>
                        {!loadingProductTypes && productTypes.map((item, index) => (
                            <a key={item.id || index}
                            onClick={() => navigate(`/menu/${item.name}`, { state: { type: item.name } })}
                            >
                                {item.name}
                            </a>
                        ))}
                    </div>

                    {/* Right Arrow */}
                    <button className="nav-btn right" onClick={() => scroll('right')}>›</button>
                </div>
            </div>

            <div className='container-fluid menu-row'>
                <div className='row m-auto'>
                    <div id="gallery">
                        <div id="header">
                            <div id="logo">MENÜ</div>
                        </div>
                        <section className="service-categories text-xs-center">
                            <div className="container-fluid">
                                <div className="row">
                                    {/* Dynamic Category Cards */}
                                    {!loadingProductTypes && productTypes.map((item) => (
                                        <div key={item.id} className="col-lg-3 col-md-4 col-sm-6 col-6" 
                                            onClick={() => navigate(`/menu/${item.name}`, { state: { type: item.name } })}>
                                            <div className="card service-card card-inverse">
                                                <div className="card-block">
                                                    <img
                                                        className="image"
                                                        src={item.image ? getOptimizedUrl(item.image, 800) : logoPlaceholder}
                                                        alt={item.name}
                                                        onError={(e) => { e.target.src = logoPlaceholder; }} 
                                                    />
                                                    <h1 className="title"><b>{item.name}</b></h1>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                {/* Floating Cart Button */}
                <a id="back-to-top" onClick={() => setShowCart(true)} className="btn login btn-lg back-to-top" role="button">
                    <i className="fas fa-cart-plus fa-xs"></i>
                </a>

                <Modal show={showCart} onHide={() => setShowCart(false)}>
                    <div className='row'>
                        <Col id='cart' lg={12}>
                            <Cart/>

                        </Col>
                    </div>

                </Modal>

                {/* <Modal show={showFeaturedModal} onHide={handleCloseFeatured} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>✨  Yeni Lezzetimiz! ✨</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        {featuredProduct && (
                            <>
                                <img 
                                    src={featuredProduct.image ? getOptimizedUrl(featuredProduct.image, 500) : logoPlaceholder} 
                                    alt={featuredProduct.name} 
                                    style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'cover', borderRadius: '8px', marginBottom: '15px' }}
                                />
                                <h3>{featuredProduct.name}</h3>
                                {featuredProduct.description && (
                                    <p className="text-muted">{featuredProduct.description}</p>
                                )}
                                <h4 style={{ color: '#e84c4f', fontWeight: 'bold' }}>
                                    {parseFloat(featuredProduct.price).toFixed(2)} ₺
                                </h4>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'center' }}>
                        <button className="btn btn-secondary" onClick={handleCloseFeatured}>
                            Belki Daha Sonra
                        </button>
                        <button className="btn btn-danger" onClick={() => {
                            handleCloseFeatured();
                            // Redirect user to the category page of this new item
                            navigate(`/menu/${featuredProduct.type}`, { state: { type: featuredProduct.type } });
                        }}>
                            Menüde Gör
                        </button>
                    </Modal.Footer>
                </Modal> */}
            </div>
            <Footer/>
        </div>
        ) : (<LoadingModal visible={ loadingProductTypes} />)
    )
}
export default Menu;